import { render, staticRenderFns } from "./sub-task-form.vue?vue&type=template&id=484d9a74&"
import script from "./sub-task-form.vue?vue&type=script&lang=js&"
export * from "./sub-task-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484d9a74')) {
      api.createRecord('484d9a74', component.options)
    } else {
      api.reload('484d9a74', component.options)
    }
    module.hot.accept("./sub-task-form.vue?vue&type=template&id=484d9a74&", function () {
      api.rerender('484d9a74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/sub-task-form.vue"
export default component.exports